/** Portion of the document that has been on screen, 0–100. */
export function documentSeenPercent({ scrollTop, scrollHeight, clientHeight }) {
  if (!scrollHeight) {
    return 0;
  }

  const seen = ((scrollTop + clientHeight) / scrollHeight) * 100;
  return Math.min(100, Math.max(0, Math.round(seen)));
}

/**
 * Scroll offset for a saved seen-percent.
 * That percent is `(scrollTop + clientHeight) / scrollHeight`, not `scrollTop / maxScroll`.
 */
export function scrollTopForSeenPercent({ scrollHeight, clientHeight }, seenPercent) {
  const maxScroll = scrollHeight - clientHeight;
  if (!scrollHeight || maxScroll <= 0) {
    return 0;
  }

  const seen = Math.min(100, Math.max(0, seenPercent)) / 100;
  const scrollTop = seen * scrollHeight - clientHeight;
  return Math.max(0, Math.min(maxScroll, scrollTop));
}
